<template>
  <div class="stratscontainer">
    <button v-if="portfolioid !== 0 && portfolioid !== null && portfolioid !== undefined && portfolioid !== ''" class="brains-type1-btn mt-2 ml-2" @click="configStrats()">
      {{ $t("configuration") }}
    </button>
    <div v-if="portfolioid !== 0 && portfolioid !== null && portfolioid !== undefined && portfolioid !== '' && stratsFiltered.length > 0" class="brains-btn-download btninline" @click="downloadAllStrats()">{{ $t('exportall') }} <font-awesome-icon icon="download" /></div>
    <div v-if="portfolioid === 0 || portfolioid === null || portfolioid === undefined || portfolioid === ''" class="container-comparables-not-selected">
      {{ $t("first-select-upload-portfolio-strats") }}
    </div>
    <div v-if="portfolioid !== 0 && portfolioid !== null && portfolioid !== undefined && portfolioid !== '' && stratsFiltered.length > 0" v-loading="loading" class="stratslist">
      <stratstable v-for="(item, index) in stratsFiltered" :key="index" ref="stratstablecontainer" :groupdata="item" />
    </div>

    <modal v-model="dialogconfigVisible">
      <div v-if="configstrat !== undefined" class="add-strat-container">
        <h2 class="config-title">{{ $t("strats-configuration") }}</h2>
        <div class="container-instructions-strats">
          <p v-html="$t('strats-instructions-1')" />
          <p v-html="$t('strats-instructions-2')" />
        </div>
        <div class="row row-gap--5 mb-3">
          <div class="col-2">
            <span>{{ $t("stratsData.group-options") }}</span>
            <el-select v-model="groupopt" class="mt-05" :placeholder="$t('stratsData.select-group-option')">
              <el-option v-for="item in configstrat.groupoptions" :key="item.id" :label="item.name" :value="item.id">
                {{ item.name }}
              </el-option>
            </el-select>
          </div>
          <div class="col-2">
            <span>{{ $t("surface") }}</span>
            <el-select v-model="areaopt" class="mt-05" :placeholder="$t('select-area')">
              <el-option v-for="item in configstrat.areaoptions" :key="item.id" :label="item.name" :value="item.id">
                {{ item.name }}
              </el-option>
            </el-select>
          </div>
          <div class="col-2">
            <span>{{ $t("value") }} 1</span>
            <el-select v-model="value1opt" class="mt-05" :placeholder="$t('stratsData.select-value') + ' 1'">
              <el-option v-for="item in configstrat.valueoptions" :key="item.id" :label="item.name" :value="item.id">
                {{ item.name }}
              </el-option>
            </el-select>
          </div>
          <div class="col-2">
            <span>{{ $t("value") }} 2</span>
            <el-select v-model="value2opt" class="mt-05" :placeholder="$t('stratsData.select-value') + ' 2'">
              <el-option v-for="item in configstrat.valueoptions" :key="item.id" :label="item.name" :value="item.id">
                {{ item.name }}
              </el-option>
            </el-select>
          </div>
          <div class="col-2 btn-add-strat-container ml-1">
            <div>
              <button class="brains-type1-btn" @click="loadstrats">{{ $t("add-strat") }}</button>
            </div>
          </div>
        </div>

        <div v-if="strats.length > 0">
          <div>
            <div class="columns-config-header">
              <div class="columns-config-header--rb">{{ $t("group-option") }}</div>
              <div class="columns-config-header--rb">{{ $t("surface-option") }}</div>
              <div class="columns-config-header--rb">{{ $t("value") }} 1</div>
              <div class="columns-config-header--rb">{{ $t("value") }} 2</div>
              <div class="columns-config-header--rb">{{ $t("userData.actions") }}</div>
            </div>
            <draggable
              v-model="strats"
              class="columns-config-dnd"
              tag="ul"
              v-bind="dragOptions"
              @start="drag = true"
              @end="drag = false"
            >
              <transition-group type="transition" :name="!drag ? 'flip-list' : null" tag="ul">
                <!--<ul>-->
                <li v-for="item in strats" :key="item" class="columns-config-row">
                  <div class="columns-config-row--rb"><font-awesome-icon class="columns-config-row--arrow" icon="arrows-alt-v" />{{ item.valuestr }}</div>
                  <div class="columns-config-row--rb">{{ item.areakeystr }}</div>
                  <div class="columns-config-row--rb">{{ item.value1keystr }}</div>
                  <div class="columns-config-row--rb">{{ item.value2keystr }}</div>
                  <div class="columns-config-row--rb"><button class="brains-type1-btn" @click="deletestrat(item)">{{ $t("portfoliosSelector.delete") }}</button></div>
                </li>
                <!--</ul>-->
              </transition-group>
            </draggable>
          </div>
        </div>
        <div class="container-footer-modal-save">
          <button class="brains-type2-btn mb-2" @click="saveportconfig()">{{ $t("saveComponent.save") }}</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import stratstable from '@/components/designComponents/portfoliostrattable.vue'
// import { saveportfolioconfig } from '@/api/portfoliouser'
import modal from '@/components/designComponents/modal'
import draggable from 'vuedraggable'
import { mapState } from 'vuex'
import { DownloadGenericTableAsXlsx } from '@/api/comparables'
export default {
  name: 'StratSselection',
  components: {
    stratstable,
    modal,
    draggable
  },
  data() {
    return {
      strats: [],
      stratsFiltered: [],
      groupopt: null,
      value1opt: null,
      value2opt: null,
      areaopt: null,
      dialogconfigVisible: false,
      firstLoad: true,
      loading: false,
      drag: false
    }
  },
  computed: {
    ...mapState('portfolio', {
      portfolioid: (state) => state.currentportfolio.id,
      configstrat: (state) => state.currentportfolio.stratsConfig,
      portfoliostrats: (state) => state.currentportfolio.stratColumns
    }),
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      }
    }
  },
  watch: {
    portfoliostrats: function() {
      const vm = this
      vm.strats = vm.portfoliostrats

      // Si es la primera carga, se añade un strat por defecto en caso de que no exista ya
      if (vm.firstLoad || vm.strats.length === 0) {
        vm.loadInitStrat()
        vm.firstLoad = false
      }
    },
    strats: function() {
      this.stratsFiltered = []
      setTimeout(() => {
        this.stratsFiltered = this.strats
      }, 50)
    }
  },
  methods: {
    downloadAllStrats() {
      const vm = this
      vm.downloadGenericTables(vm.$refs.stratstablecontainer.map((item) => {
        return 'stratstable' + item._uid
      }))
    },
    downloadGenericTables(tableClasses) {
      // debugger
      var tableAsArray = []
      var rowSpanControl = {}
      tableClasses.forEach((tableClass, index) => {
        var tableDOM = document.querySelector('.' + tableClass)
        var childElements = tableDOM.childNodes

        for (var i = 0; i < childElements.length; i++) {
          if (childElements[i].localName === 'thead' || childElements[i].localName === 'tbody' || childElements[i].localName === 'tfooter') {
            var tableSection = childElements[i].childNodes
            for (var j = 0; j < tableSection.length; j++) {
              tableAsArray.push(iterateRow(tableSection[j]))
            }
          } else {
            tableAsArray.push(iterateRow(childElements[i]))
          }
        }
      })

      function iterateRow(rowNode) {
        var arrayToAdd = []
        var colsInRow = rowNode.childNodes

        for (var k = 0; k < colsInRow.length; k++) {
          if (!!rowSpanControl[k] && rowSpanControl[k] > 1) {
            arrayToAdd.push('')
            rowSpanControl[k] = rowSpanControl[k] - 1
          }
          if (colsInRow[k].rowSpan > 1) {
            rowSpanControl[k] = colsInRow[k].rowSpan
          }
          for (var y = 0; y < colsInRow[k].colSpan; y++) {
            arrayToAdd.push(y === 0 ? colsInRow[k].innerText : '')
          }
        }
        return arrayToAdd
      }

      DownloadGenericTableAsXlsx(tableAsArray)
        .then((response) => {
          const blob = new Blob([response.data], { type: 'application/octet-stream' })
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'TableExport.xlsx'
          link.click()
        })
    },
    /**
     * Se añade un strat por defecto en caso de que no haya ninguno creado con anterioridad
     */
    loadInitStrat() {
      // this.loading = true
      const vm = this
      setTimeout(() => {
        try {
          if (vm.strats.length === 0) {
            // En la opción de group se escogera el primer feature disponible, en caso contrario sera a mano
            var groupoptvalue = vm.configstrat.groupoptions.filter(item => { return item.name.includes('Region') })
            // Primero se revisa si ha encontrado por Region, en caso contario comprueba Province y luego un Feature
            // si despues de todo eso no ha encontrado nada, cogera el primer valor disponible
            if (groupoptvalue.length === 0) {
              groupoptvalue = vm.configstrat.groupoptions.filter(item => { return item.name.includes('Province') })
            }

            if (groupoptvalue.length === 0) {
              groupoptvalue = vm.configstrat.groupoptions.filter(item => { return item.id.includes('Feature') })
            }

            if (groupoptvalue.length === 0) {
              groupoptvalue = vm.configstrat.groupoptions[0].id
            } else {
              vm.groupopt = groupoptvalue[0].id
            }

            // Primeros valores disponibles
            // debugger
            vm.value1opt = vm.configstrat.valueoptions[0].id
            vm.value2opt = vm.configstrat.valueoptions[0].id
            vm.areaopt = vm.configstrat.areaoptions[0].id
            vm.loadstrats()
          }
        } catch (error) {
          vm.$message({
            showClose: true,
            message: this.$t('something-went-wrong-loading-firststrat'),
            type: 'error'
          })
        }

        // vm.loading = false
      }, 600)
    },
    deletestrat(item) {
      const vm = this
      vm.strats = vm.strats.filter((ob) => {
        return ob !== item
      })
    },
    configStrats() {
      this.dialogconfigVisible = true
    },
    saveportconfig() {
      const vm = this
      vm.loading = true
      console.log(vm.strats)
      const data = {
        id: vm.portfolioid,
        stratsconfig: vm.strats,
        type: 'strats'
      }
      vm.$store.dispatch('portfolio/saveportfolioconfig', data)
        .then((response) => {
          this.dialogconfigVisible = false
          this.loading = false
        })
        .catch(() => {
          vm.$message({
            showClose: true,
            message: this.$t('something-went-wrong-saving-conf'),
            type: 'error'
          })
          vm.loading = false
        })
    },
    loadstrats() {
      const vm = this
      vm.loading = true
      if (vm.groupopt === null || vm.value1opt === null || vm.value2opt === null || vm.areaopt === null) {
        vm.$message({
          showClose: true,
          message: this.$t('select-all-options'),
          type: 'error'
        })
        vm.loading = false
        return
      }
      vm.strats.push({
        idportfolio: vm.portfolioid,
        valuekey: vm.groupopt,
        valuestr: vm.configstrat.groupoptions.filter((item) => item.id === vm.groupopt)[0].name,
        value1key: vm.value1opt,
        value2key: vm.value2opt,
        value1keystr: vm.configstrat.valueoptions.filter((item) => item.id === vm.value1opt)[0].name,
        value2keystr: vm.configstrat.valueoptions.filter((item) => item.id === vm.value2opt)[0].name,
        areakey: vm.areaopt,
        areakeystr: vm.configstrat.areaoptions.filter((item) => item.id === vm.areaopt)[0].name
      })

      // Se vuelven a inicializar los campos
      this.groupopt = null
      this.value1opt = null
      this.value2opt = null
      this.areaopt = null

      vm.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.btninline {
  display: inline;
  margin-left: 10px;
}
.columns-config-header {
  display: grid;
  border-bottom: 2px solid #1e3cff;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  grid-template-columns: repeat(5, 1fr);
  font-family: 'Montserrat-SemiBold',sans-serif;
  font-size: 14px;

  &--rb {
    padding: 6px 0;
  }
}

.columns-config-dnd {

  .columns-config-row {
    cursor: grab;
    font-family: 'Montserrat-Light',sans-serif;
    display: grid;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    grid-template-columns: repeat(5, 1fr);
    border-bottom: 1px solid #c2c2c2;
    font-size: 13px;
    position: relative;

    &--rb {
      padding: 6px 0;
    }

    &--arrow {
      position: absolute;
      left: 20px;
      color: grey;
    }
  }
}

.stratslist {
  height: calc(100vh - 200px);
  overflow: auto;
  width: 100%;
  overflow-x: hidden;
}

.stratcomponent {
  margin: 10px;
  margin-bottom: 20px;
}

.add-strat-container {
  padding: 25px 20px 25px 20px;

  .config-title {
    font-size: 20px;
    font-family: "Montserrat-SemiBold",sans-serif;
    margin-bottom: 25px;
  }
}

.btn-add-strat-container {
  display: flex;
  justify-content: flex-end;
  flex-direction: column;

  div {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding-bottom: 3px;
  }
}

.container-footer-modal-save {
  text-align: right;
  margin-top: 20px;
}

.container-table-list-strats {
  max-height: 350px;
  overflow: scroll;
}

.container-instructions-strats {
  margin-bottom: 30px;
  p {
    margin-bottom: 10px;
    line-height: 22px;
  }
}
</style>
